enum ErrorCode {
  PERMISSION_DENIED = 1,
  POSITION_UNAVAILABLE = 2,
  TIMEOUT = 3,
  PLAY_SERVICE_NOT_AVAILABLE = 4,
  SETTINGS_NOT_SATISFIED = 5,
  INTERNAL_ERROR = -1,
}

export const locationPermission = () => {};

export const locationPermissionErrorHandler = (code: number) => {
  switch (code) {
    case ErrorCode.PERMISSION_DENIED:
      console.warn('Permission denied');
      break;
    case ErrorCode.POSITION_UNAVAILABLE:
      console.warn('Position not available');
      break;
    case ErrorCode.TIMEOUT:
      console.warn('Location request timeout');
      break;
    case ErrorCode.SETTINGS_NOT_SATISFIED:
      console.warn('Settings are not satisfied');
      break;
    case ErrorCode.INTERNAL_ERROR:
      console.warn('Internal Error in Location Service');
      break;
    case ErrorCode.PLAY_SERVICE_NOT_AVAILABLE:
      console.warn('Google play service is not available');
      break;
    default:
      console.warn('Unhandled error occurred');
      break;
  }
};
